import {
  Box,
  Flex,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";
import React from "react";

const WhoSpeakFirst = ({ watch, getValues, setValue, register }) => {
  return (
    <Flex direction={"column"} gap={4}>
      <Box mt="3" display="flex">
        <FormLabel htmlFor="speaks_first" mb="0">
          <b>Who speaks first?</b>
        </FormLabel>
        <RadioGroup
          id="speaks_first"
          value={getValues("attributes.speaks_first")}
          onChange={(value) => {
            setValue("attributes.speaks_first", value);
            if (value === "user") {
              setValue("attributes.first_sentence", "");
            }
          }}
        >
          <Stack direction="row" spacing={4}>
            <Radio value="assistant">Assistant</Radio>
            <Radio value="user">User</Radio>
          </Stack>
        </RadioGroup>
      </Box>
      {watch("attributes.speaks_first") === "assistant" ? (
        <Box maxW={"350px"}>
          <FormLabel htmlFor="first_sentence" mb="0">
            Assistant speaks
          </FormLabel>
          <Input
            placeholder="auto-generated using your prompt"
            {...register("attributes.first_sentence")}
            defaultValue={""}
          />
        </Box>
      ) : null}
    </Flex>
  );
};

export default WhoSpeakFirst;
